
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources05On as ObiSources05OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-05-on.js';
 
 
 

 
 export const ObiSources05On = createComponent({
   react: React,
   tagName: 'obi-sources-05-on',
   elementClass: ObiSources05OnElement,
   events: {
     
   }
  });
 
 